import React, { useEffect, useState } from "react";
import { CgClose } from "react-icons/cg";
import { useGetEditOnlineInvoice } from "../../hooks/useCrm";
import { formatDate } from "../../utils/formatDate";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { BootstrapModal } from "../BootstrapModal/Modal";
import Button from "../Button/Button";
import { DataPicker } from "../DataPicker/DataPicker";
const initValue = {
  IdOrderOnline: null,
  DateNew: null,
};
export const EditOnlineInvoiceModal = ({ show, handleClose, factor }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initValue);
  const { mutateAsync: EditFactor } = useGetEditOnlineInvoice();

  useEffect(() => {
    setForm({
      ...form,
      IdOrderOnline: factor?.IdOrderOnline,
    });
  }, [factor]);
  const handleEdit = async (data) => {
    await EditFactor(data).then(() => setForm(initValue));
  };
  return (
    <BootstrapModal
      modaltitle="ویرایش فاکتور"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <DataPicker
            label={`تاریخ جدید (تاریخ فعلی${MiladiToShamsi(
              factor?.created_at
            )})`}
            onChange={(e) => setForm({ ...form, DateNew: formatDate(e) })}
          />
        </div>
        <div className="col-6 mt-3">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleEdit(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
        <div className="col-6 mt-3">
          <Button
            bgColor="#f1416c"
            color="#fff"
            onclick={() => {
              handleClose();
            }}
          >
            انصراف
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
